import { ToDo } from "./todo.interface";


export const todos: ToDo[] = [
  {
    id: 1,
    message: 'Factura 1',
    completionStatus: true,
    edit: false,
    date: new Date('02-06-2023'),
  },
  {
    id: 2,
    message: 'Factura 2',
    completionStatus: false,
    edit: false,
    date: new Date('02-08-2023'),
  },
  {
    id: 3,
    message: 'Factura 3',
    completionStatus: true,
    edit: false,
    date: new Date('02-10-2023'),
  },
  {
    id: 4,
    message: 'Factura 4',
    completionStatus: false,
    edit: false,
    date: new Date('02-12-2023'),
  },
  {
    id: 5,
    message: 'Factura 6',
    completionStatus: false,
    edit: false,
    date: new Date('02-15-2023'),
  },
  {
    id: 6,
    message: 'Factura 7',
    completionStatus: false,
    edit: false,
    date: new Date('02-15-2023'),
  },
];
